import { GenericCollectionFactory } from "../../_generics";
import { GENERIC_IDS } from "../../_constants/generics.constants";

export const ClockinStore = GenericCollectionFactory(GENERIC_IDS.CLOCKINS, "uid");